import React, { useState, useEffect } from 'react'
import { Plus } from '@phosphor-icons/react'
import DropInTicketComp from './DropInTicketComp'
import DropInTickets from '../Modals/DropinTicket/DropInTickets'
import { classesEventStore } from 'state/classes/classesStore'
import { useGetClassesStep6DropInTicket } from 'api/Classes/Step6Tickets/Tickets' 

const DropInTicketRow: React.FC = () => {
  const { admissionTickets, dropInTicket, _id } = classesEventStore(
    store => store.classesData,
  ) as any

  const [dropInModalOpen, setDropInModalOpen] = useState<boolean>(false)
  
  const {
    data: dropInTicketData,
    isLoading: dropInTicketLoading,
    refetch: dropInTicketRefetch
  } = useGetClassesStep6DropInTicket(_id)

  const handleAddClick = () => {
    setDropInModalOpen(true)
  }

  return (
    <>
      <div className="mt-20px">
        <div className="flex align-center justify-between ">
          <div>
            <p className="text-16 w-600">Drop-in Ticket</p>
          </div>
          {!_id || !dropInTicketData || !dropInTicketData._id ? (
            <div
              className="w-36px h-36px radius-rounded bg-blue flex align-center justify-center pointer"
              onClick={handleAddClick}
            >
              <Plus size={12} color="#fff" />
            </div>
          ) : null}
        </div>

        <div className="grid-50">
            {_id && dropInTicketData && dropInTicketData._id && (
              <DropInTicketComp 
                details={dropInTicketData}
              />
            )}
          </div>
      </div>

      {dropInModalOpen && (
        <DropInTickets
          modalOpen={dropInModalOpen}
          modalClose={setDropInModalOpen}
        />
      )}
    </>
  )
}

export default DropInTicketRow
